module.exports = __webpack_public_path__ + "img/039-file-text2.e46a1752.svg";